PJQ.collections.bidForms = {};

PJQ.models.bidForms = {};

PJQ.views.bidForms = {};

function initBidFormsAdmin() {
	if (!PJQ.app.BidFormEditor) {
		let initProposalId = PJQ.helpers.urlHelpers.getQueryParam('proposal');
		if (_.size(initProposalId) > 0) {
			initProposalId = parseInt(initProposalId);
		}
		PJQ.app.BidFormEditor = new PJQ.views.bidForms.BidFormEditorSelector({
			el: '#project-bidforms',
			project: PJQ.app.session.project,
			collection: new PJQ.collections.bidForms.GroupBidForms([]),
			initProposalId: initProposalId
		});
	}
}

function initBidFormsSub() {
	new PJQ.views.bidForms.BidFormViewerSelectorModal({
		model: new PJQ.models.bidForms.Bidder({
			contactId: PJQ.app.session.contact.id
		})
	});
}

PJQ.modules.bidForms = {
	routes: [
		{
			route: 'projects/:projectId/bidforms',
			name: 'projectBidForms',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "bidforms");
			}
		},
		{
			route: 'projects/:projectId/bidforms/:groupId',
			name: 'projectProposal',
			callback: function (projectId, groupId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "bidforms", {
					groupId: parseInt(groupId)
				});
			}
		},
		{
			route: 'projects/:projectId/proposals/:proposalId',
			name: 'projectProposal',
			callback: function (projectId, proposalId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "bidforms", {
					proposalId: parseInt(proposalId)
				});
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.bidForms.routes);